import PropTypes from 'prop-types';
import React from 'react';
import {Button} from '@material-ui/core';
import {
  createMuiTheme,
  ThemeProvider as MuiThemeProvider,
  withStyles,
} from '@material-ui/core/styles';
import {
  blue,
  red,
} from '@material-ui/core/colors';

const styles = () => ({
  root: {
    height: '48px;',
  },
});

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: red,
  },
});

const RideRequestButton = ({dataId, label, ...other}) => (
  <MuiThemeProvider theme={theme}>
    <Button
      data-id={dataId}
      fullWidth
      size="large"
      variant="contained"
      {...other}
    >
      {label}
    </Button>
  </MuiThemeProvider>
);

RideRequestButton.propTypes = {
  dataId: PropTypes.string,
  label: PropTypes.string.isRequired,
};

export default withStyles(styles)(RideRequestButton);



// WEBPACK FOOTER //
// ./src/ondemand/components/RideRequestButton.js